import type { GridApi } from '@mint-lib/ag-grid/community';
import { useTranslation } from '@mint-lib/i18n';
import { Skeleton } from '@mint-lib/tw-components';
import { MediaPlan } from '@mint-sdk/api-media-plan';

import { useMediaItemChildOptionsApi } from '../../../../../../api/queries/useMediaItemChildOptionsApi.js';
import AddMediaItems from './AddMediaItems.jsx';
import AddMediaRows from './AddMediaRows.jsx';

type AddRowInsideProps = {
  mediaData: MediaPlan.MediaData;
  closeMenu: () => void;
  api: GridApi<MediaPlan.MediaData>;
};

const AddRowInside = ({ mediaData, closeMenu, api }: AddRowInsideProps) => {
  const { t } = useTranslation('@myn/planning_v2');
  const {
    data: childOptions,
    isLoading,
    isError,
  } = useMediaItemChildOptionsApi(mediaData.mediaItemId);

  const isAddingMediaRows =
    childOptions?.levelType === MediaPlan.LevelTypeEnum.enum.media_row;

  if (isError) {
    return (
      <div className="w-74 px-3 py-1">
        <h6 className="mb-0 text-sm text-text-error">
          {t('Something went wrong while loading. Please try again.')}
        </h6>
      </div>
    );
  }

  if (isLoading || !childOptions) {
    return (
      <div className="flex w-74 flex-col gap-2 px-3 py-1">
        <div className="mb-1 flex items-center gap-2">
          <Skeleton className="h-5 w-full" />
          <Skeleton className="h-6 w-11" />
        </div>
        <div className="flex flex-col gap-1">
          <Skeleton className="h-4" />
          <Skeleton className="h-8" />
        </div>
      </div>
    );
  }

  if (isAddingMediaRows) {
    return <AddMediaRows mediaData={mediaData} onClose={closeMenu} api={api} />;
  }

  return (
    <AddMediaItems
      childOptions={childOptions}
      mediaData={mediaData}
      onClose={closeMenu}
      api={api}
    />
  );
};

export default AddRowInside;
